import {
    IValidation,
    email,
    maxLength,
    minLength,
    onlyNumbers,
    required,
    secureValue,
} from '@vfde-brix/ws10/validation';
import { ValidatorErrorKey } from 'Container/LeadManagementSystemForm/enum';

const REQUIRED_VALIDATION_CONFIG: IValidation = {
    validator: required,
    errorKey: ValidatorErrorKey.REQUIRED,
};

const MAX_LENGTH_HOUSE_NUMBER_CONFIG: IValidation = {
    validator: maxLength,
    errorKey: ValidatorErrorKey.MAX_LENGTH_HOUSE,
    maxLength: 5,
};

const MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG: IValidation = {
    validator: minLength,
    errorKey: ValidatorErrorKey.MIN_LENGTH_ZIP,
    minLength: 4,
};

const MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG: IValidation = {
    validator: maxLength,
    errorKey: ValidatorErrorKey.MAX_LENGTH_ZIP,
    maxLength: 5,
};

const ONLYNUMBERS_VALIDATION_CONFIG: IValidation = {
    validator: onlyNumbers,
    errorKey: ValidatorErrorKey.ONLY_NUMBERS,
};

const SECURE_VALUE_VALIDATION_CONFIG: IValidation = {
    validator: secureValue,
    errorKey: ValidatorErrorKey.SECURE_VALUE,
};

const MAX_LENGTH_CITY_VALIDATION_CONFIG: IValidation = {
    validator: maxLength,
    errorKey: ValidatorErrorKey.MAX_LENGTH_CITY,
    maxLength: 30,
};

const MAX_LENGTH_STREET_VALIDATION_CONFIG: IValidation = {
    validator: maxLength,
    errorKey: ValidatorErrorKey.MAX_LENGTH_STREET,
    maxLength: 50,
};

const MIN_LENGTH_MOBILE_VALIDATION_CONFIG: IValidation = {
    validator: minLength,
    errorKey: ValidatorErrorKey.MIN_LENGTH_MOBILE,
    minLength: 6,
};

const MAX_LENGTH_MOBILE_VALIDATION_CONFIG: IValidation = {
    validator: maxLength,
    errorKey: ValidatorErrorKey.MAX_LENGTH_MOBILE,
    maxLength: 13,
};

const EMAIL_VALIDATION_CONFIG: IValidation = {
    validator: email,
    errorKey: ValidatorErrorKey.EMAIL,
};

const MAX_LENGTH_70_VALIDATION_CONFIG: IValidation = {
    validator: maxLength,
    errorKey: ValidatorErrorKey.MAX_LENGTH_70,
    maxLength: 70,
};

const MAX_LENGTH_800_VALIDATION_CONFIG: IValidation = {
    validator: maxLength,
    errorKey: ValidatorErrorKey.MAX_LENGTH_800,
    maxLength: 800,
};

// TODO: not in use? -> remove
/*const CONTACT_METHOD_PHONE_VALIDATION_CONFIG: IValidation = {
    validator: validateContactPhoneInput,
    errorKey: ValidatorErrorKey.REQUIRED,
};

const CONTACT_METHOD_CITY_VALIDATION_CONFIG: IValidation = {
    validator: validateContactCityInput,
    errorKey: ValidatorErrorKey.REQUIRED,
};*

const EMAIL_MANDATORY_VALIDATION_CONFIG: IValidation = { // TODO: remove if not needed
    validator: emailMandatoryValidator,
    errorKey: ValidatorErrorKey.REQUIRED,
};*/

export default {
    required: REQUIRED_VALIDATION_CONFIG,
    onlyNumbers: ONLYNUMBERS_VALIDATION_CONFIG,
    secureValue: SECURE_VALUE_VALIDATION_CONFIG,
    email: EMAIL_VALIDATION_CONFIG,
    maxLengthCity: MAX_LENGTH_CITY_VALIDATION_CONFIG,
    maxLengthStreet: MAX_LENGTH_STREET_VALIDATION_CONFIG,
    maxLengthHouse: MAX_LENGTH_HOUSE_NUMBER_CONFIG,
    maxLengthZip: MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
    maxLengthMobile: MAX_LENGTH_MOBILE_VALIDATION_CONFIG,
    maxLength70: MAX_LENGTH_70_VALIDATION_CONFIG,
    maxLength800: MAX_LENGTH_800_VALIDATION_CONFIG,
    minLengthZip: MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
    minLengthMobile: MIN_LENGTH_MOBILE_VALIDATION_CONFIG,
};
